import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the texts of the emails (FR-M14-05, ADR-149): every template, by code and language, at once.

const templates = api.notifications.templates;

type Templates = InferResponseType<typeof templates.$get, 200>;
export type NotificationTemplate = Templates["items"][number];

const keys = { all: ["notification-templates"] as const };

export const templateQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: ({ signal }) => unwrap(templates.$get({}, { init: { signal } })),
    }),
};
